const RecentlyViewedEl = document.getElementById('recently-viewed-grid')
const RecentlyViewedApp = Vue.createApp({
    components: {
        'product': ProductGridItem,
        'currency': ProductGridPrice,
        'modal': QuickViewModal,
        'notify': NotifyMeModal,
    },
    props: ['id','handle'],
    data() {
        return {
            products: [],
            i18n: {},
            cartAddUrl: '/cart/add.js',
            showModal: false,
            showNotify: false,
            modalLoading: false,
            notifyLoading: false,
            notifySuccess: false,
            notifyItem: null,
            quickViewItem: {},
            quickViewItems: {},
            recentlyViewedProductsCookie: Cookies.get('evanhealyRecentlyViewedProducts'),
            recentlyViewedProductsHandles: null
        }
    },
    created() {
        this.fetchHeaders = new Headers();
        this.fetchHeaders.append('pragma', 'no-cache');
        this.fetchHeaders.append('cache-control', 'no-store');
        this.fetchHeaders.append('Content-Type', 'application/json');
        this.cartNotification = document.querySelector('cart-notification');
        try {
            if (this.recentlyViewedProductsCookie === undefined) {
                Cookies.set('evanhealyRecentlyViewedProducts', JSON.stringify([this.handle]));
            } else {
                this.recentlyViewedProductsHandles = JSON.parse(this.recentlyViewedProductsCookie);
                if ( !this.recentlyViewedProductsHandles.includes(this.handle) ) {
                    this.recentlyViewedProductsHandles.unshift(this.handle);
                    Cookies.set('evanhealyRecentlyViewedProducts', JSON.stringify(this.recentlyViewedProductsHandles));
                }
                const recentlyViewedList = this.recentlyViewedProductsHandles.slice(0, 20);
                const recentlyViewedListLength = recentlyViewedList.length;
                let data = [];
                let processed = 0;
                recentlyViewedList.forEach((handle,index) => {
                    const url = '/products/' + handle + '/?section_id=product-data'
                    fetch(url)
                        .then(response => response.text())
                        .then(text => {
                            const sectionInnerHTML = new DOMParser()
                                .parseFromString(text, 'text/html')
                                .getElementById('product-data');
                            if(sectionInnerHTML) {
                                const product = JSON.parse(sectionInnerHTML.innerText);
                                data.push(product);
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                        .finally(() => {
                            processed++;
                            if(processed === recentlyViewedListLength) {
                                this.updateLocations(data).then(() => {
                                    data = data.filter(product => product.found === true);
                                    data.sort((a,b) => b.available - a.available);
                                    this.products = data;
                                });
                                this.updatePage();
                            }
                        });
                });
            }
        } catch (e) {
            console.error(e);
        }
        if(window.evanhealy_settings && window.evanhealy_settings.i18n) {
            this.i18n = window.evanhealy_settings.i18n;
        }
    },
    methods: {
        updatePage() {
            setTimeout(() => {
                const event = new CustomEvent("ehUpdateRecentlyViewed");
                window.dispatchEvent(event);
            },250);
        },
        addToCart(qty,variantId,gridItem) {
            const data = {
                items: []
            };
            const item = {id: variantId, quantity: qty};
            data.items.push(item);
            const body = JSON.stringify(data);
            this.modalLoading = true;
            this.products.forEach((product) => {
                if(product.id === gridItem.id) {
                    product.loading = true;
                }
            });
            fetch(this.cartAddUrl,{method: 'POST', headers: this.fetchHeaders , body})
                .then((response) => {
                    this.showModal = false;
                    this.modalLoading = false;
                    this.updateCart(response);
                })
                .catch((e) => {
                    console.error(e);
                }).finally(() => {
                this.modalLoading = false;
                this.products.forEach((product) => {
                    product.loading = false;
                });
            });
        },
        updateCart(response) {
            const event = new CustomEvent("ehAddProductToCart", {detail: response});
            window.dispatchEvent(event);
            this.cartNotification.renderContents(response);
        },
        decodeHtml(html) {
            const txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        openQuickView(item) {
            if(this.quickViewItems.hasOwnProperty(item.id)) {
                this.showQuickViewModal(this.quickViewItems[item.id])
            } else {
                const url = '/products/' + item.handle + '.js'
                fetch(url)
                    .then(response => response.json())
                    .then((response) => {
                        response['certification_logos'] = this.decodeHtml(item.certification_logos);
                        response['subtitle'] = item.subtitle;
                        response['selected_or_first_available_variant'] = item.selected_or_first_available_variant;
                        response['selected_or_first_available_selling_plan'] = item.selected_or_first_available_selling_plan;
                        response['variants'] = item.variants;
                        this.quickViewItems[item.id] = response;
                        this.showQuickViewModal(response)
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
        },
        openNotifyModal(item) {
            document.body.classList.add('overflow-hidden');
            this.showNotify = true;
            this.notifyItem = item;
        },
        submitNotify(email,variantId) {
            if(!email || !variantId) {
                return false;
            }
            this.notifyLoading = true;
            backInStockSubscription(email,variantId)
                .then((response) => {
                    this.notifySuccess = true;
                    this.notifyLoading = false;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.notifyLoading = false;
                });
        },
        showQuickViewModal(item) {
            document.body.classList.add('overflow-hidden');
            this.showModal = true;
            this.quickViewItem = item;
        }
    },
    template: `
        <div class="collection page-width" v-if="products.length > 0">
            <h2 class="product-recommendations__heading">Recently viewed</h2>
            <div class="grid grid--2-col product-grid grid--3-col-tablet grid--one-third-max grid--4-col-desktop grid--quarter-max recently-viewed-grid swiper">
                <div class="grid__item swiper-slide" v-for="(product, index) in products" :key="product.id">
                    <product
                         :item="product"
                         custom-class="swiper-slide"
                         :i18n="i18n"
                         @add-to-cart="addToCart"
                         @open-quick-view="openQuickView"
                         @open-notify-modal="openNotifyModal"
                    ></product>
                </div>
            </div>
        </div>
        <modal v-if="products.length > 0" :show="showModal" :loading="modalLoading" :item="quickViewItem" @add-to-cart="addToCart" @close="showModal = false"></modal>
        <notify v-if="products.length > 0" :show="showNotify" :loading="notifyLoading" :submitted="notifySuccess" :item="notifyItem" @submit-notify="submitNotify" @close="showNotify = false; notifySuccess = false;"></notify>`
}, { ...RecentlyViewedEl.dataset })
RecentlyViewedApp.use(ehPlugin);
RecentlyViewedApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api')
RecentlyViewedApp.config.unwrapInjectedRef = true
RecentlyViewedApp.mount('#recently-viewed-grid')
